import { defineMessages } from 'react-intl';

const messages = defineMessages({
  sampleMessage: {
    id: 'sample.message',
    defaultMessage: 'My sample message',
    description: 'This is a sample message for testing',
  },
});

export default messages;
